import React, { useCallback } from 'react';
import cn from 'classnames';
import { sanitizeFullName } from 'Shared/helpers';
import identity from 'lodash/identity';
import { useField } from 'react-final-form';
import { AvatarType } from 'Shared/constants/types';

import { SimpleAvatar as Avatar } from 'Shared/components/Avatar/Avatar';

type PropType = {
  workspace?: {
    uuid: string;
    fullName?: string;
    avatar?: AvatarType;
    workspaceName?: string;
    isGroup?: boolean;
  };
};

export default function Box({ workspace }: PropType) {
  const { uuid, fullName, isGroup, workspaceName, avatar } = workspace || {};
  const {
    input: { value: currentWorkspace, onChange },
  } = useField('currentWorkspace');

  const handleClick = useCallback(() => {
    onChange(uuid);
  }, [onChange, uuid]);

  const boxContents = () => {
    if (!isGroup && fullName) {
      return (
        <>
          <Avatar uuid={uuid} avatar={avatar} />
          <p className="onboarding-workspaces-preview-side-box-label">{sanitizeFullName(fullName)}</p>
        </>
      );
    }

    if (isGroup && workspaceName) {
      return (
        <>
          <Avatar uuid={uuid} avatar={avatar} />
          <p className="onboarding-workspaces-preview-side-box-label">{workspaceName}</p>
        </>
      );
    }

    return null;
  };

  return (
    <div
      className={cn('onboarding-workspaces-preview-side-box', {
        'onboarding-workspaces-preview-side-box--checked': currentWorkspace && currentWorkspace === uuid,
        'onboarding-workspaces-preview-side-box--clickable': !!fullName,
      })}
      onClick={fullName ? handleClick : identity}
    >
      {boxContents()}
    </div>
  );
}
